import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trackingurl',
  templateUrl: './trackingurl.component.html',
  styleUrls: ['./trackingurl.component.css']
})
export class TrackingurlComponent implements OnInit {
  key:any = 'G-MHSZ5HJVEJ';
  constructor() { }

  ngOnInit(): void {
    console.log("Inside GA4-URL component");
    try {
      var script1 = document.createElement('script');
      script1.async = true;
      // script1.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.key;
      // document.head.appendChild(script1);
      // var script2 = document.createElement('script');
      // script2.innerHTML = "\n        window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n        gtag('config', '" + this.key + "', {'send_page_view': true});\n      ";
      //document.head.appendChild(script2);
      var script3 = document.createElement('script');
      script3.innerHTML = "\n        gtag('event', 'screen_view', {'app_name': 'myAppName','screen_name': 'Email' });\n        ";
      document.head.appendChild(script3);
      console.log("GA4: Script append");
    }
    catch (ex) {
        console.error('Error appending google analytics');
        console.error(ex);
    }
  }
}